// ENVIRONMENT VARIABLES

export const AWS_APPSYNC_URL = process.env.AWS_APPSYNC_URL as string;
export const AWS_APPSYNC_REGION = process.env.AWS_APPSYNC_REGION as string;
export const AWS_APPSYNC_API_KEY = process.env.AWS_APPSYNC_API_KEY as string;
export const CONTENTFUL_SPACE = process.env.CONTENTFUL_SPACE as string;
export const CONTENTFUL_ACCESS_TOKEN_DRAFTS = process.env.CONTENTFUL_ACCESS_TOKEN_DRAFTS as string;